<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col>
                    <v-icon @click="isColorPickerOpen = !isColorPickerOpen" color="primary">mdi-brush-outline</v-icon>
                </v-col>
                <v-col class="text-left">
                    <v-btn-toggle v-model="selectedChart"
                                  shaped
                                  mandatory>
                        <v-btn value="chart1">
                            {{$t('ChartOne')}}
                        </v-btn>

                        <v-btn value="chart2">
                            {{$t('ChartTwo')}}
                        </v-btn>

                        <v-btn value="chart3">
                            {{$t('ChartThree')}}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
            <!-- Color Picker Dialog -->
            <v-dialog v-model="isColorPickerOpen" max-width="400">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-color-picker v-model="chartColor" mode="hexa"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" text @click="isColorPickerOpen = false">
                            {{$t('Close')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-card-text>

        <v-card-text v-if="selectedChart === 'chart1'" style="margin:auto; margin-right: 40px; margin-top: 10px;">
            <table style="width:100%">
                <tr v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                    <td style="padding-top:10px"><table style="background-color: #f2f2f2; width: 100%; height: 35px; padding: 0px 10px; color: #3090A0; font-size: 21px;"><tr><td>{{ item.name }}</td><td style="width:20%">
    <img height="40" v-if="item.name == 'سناب شات'" src="../../assets/images/snap.png" />
    <img height="40" v-if="item.name == 'واتساب'" src="../../assets/images/Wats.png" />
    <img height="40" v-if="item.name == 'تيك توك'" src="../../assets/images/TikTok.png" />
    <img height="40" v-if="item.name == 'تيليجرام'" src="../../assets/images/Telegram.png" />
    <img height="40" v-if="item.name == 'أخرى'" src="../../assets/images/Other.png" />
    <img height="40" v-if="item.name == 'رسالة نصية من الوزارة'" src="../../assets/images/Sms.jpg" />
    <img height="40" v-if="item.name == 'متطوعين'" src="../../assets/images/Group.png" />
    <img height="40" v-if="item.name == 'QR كود'" src="../../assets/images/Qr.png" />
    <img height="40" v-if="item.name == 'منصة الإستبيانات'" src="../../assets/images/Survey.png" />
    <img height="40" v-if="item.name == 'منصة اكس (تويتر سابقاً)'" src="../../assets/images/X.png" />
</td></tr></table></td>
                    <td style="width: 45%; padding-top: 10px"><div class="chart-bar" :style="{ width: item.value + '%', backgroundColor:chartColor }"><div style="width:50px; font-size: 21px;">{{ item.value }}%</div></div></td>
                </tr>
            </table>
            <!--<div class="chart-item" v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                <v-row>
                    <v-col cols="2">
                        <table style="background-color: #f2f2f2; width: 100%; height: 35px; padding: 0px 10px; color: #3090A0">
                            <tr>
                                <td>{{ item.name }}</td>
                                <td style="width:20%">
                                    <img height="40" v-if="item.name == 'سناب شات'" src="../../assets/images/snap.png" />
                                    <img height="40" v-if="item.name == 'واتساب'" src="../../assets/images/Wats.png" />
                                    <img height="40" v-if="item.name == 'تيك توك'" src="../../assets/images/TikTok.png" />
                                    <img height="40" v-if="item.name == 'تيليجرام'" src="../../assets/images/Telegram.png" />
                                    <img height="40" v-if="item.name == 'أخرى'" src="../../assets/images/Other.png" />
                                    <img height="40" v-if="item.name == 'رسالة نصية من الوزارة'" src="../../assets/images/Sms.jpg" />
                                    <img height="40" v-if="item.name == 'متطوعين'" src="../../assets/images/Group.png" />
                                    <img height="40" v-if="item.name == 'QR كود'" src="../../assets/images/Qr.png" />
                                    <img height="40" v-if="item.name == 'منصة الإستبيانات'" src="../../assets/images/Survey.png" />
                                    <img height="40" v-if="item.name == 'منصة اكس (تويتر سابقاً)'" src="../../assets/images/X.png" />
                                </td>
                            </tr>
                        </table>
                    </v-col>

                    <v-col>
                        <div class="chart-bar" :style="{ width: item.value + '%', backgroundColor:chartColor }"><div style="width:30px">{{ item.value }}%</div></div>
                    </v-col>
                </v-row>



            </div>-->
        </v-card-text>
        <v-card-text v-if="selectedChart === 'chart2'" style="position: relative; height: 350px; margin: auto; margin-right: 80px; margin-top: 20px;">
            <table><tr>
    <td style="width:auto;max-width:400px">
        <div style="height: 200px; margin-top: 10px; font-size: 21px;">
            <ul style="float:left;">
                <li v-for="(item, index) in value" :key="index"> <table><tr><td>{{item.name}}</td><td><img src="/comsep.png" style="height:5px" /></td><td>{{item.value}}%</td></tr></table></li>

            </ul>
            <div style="clear:both"></div>
            <div :style="`background: linear-gradient(to right, #2fbcd3, ${chartColor});margin-top:30px;border-radius:20px;padding:20px;width:200px`" class="text-center">
                <img src="/comreason.png" style="width:50px" /><br />
                <span class="white--text">{{$t('CommnicationReason')}}</span>
            </div>
        </div>
    </td>
    <td>
        <div class="circular-arc-container">
            <div v-for="(item, index) in value.filter(x=>x.value>0)" :key="'circle'+index" class="circular-arc" :style="`width:${ 200 - (40 * index)}px;height:${ 200 - (40 * index) }px;clip-path: inset(0px 0px ${50 + (index * 10)}% 0px); margin-top: ${(index == 0?0:(-200 + ((index == 1?20:30) * index))) }px; margin-right: ${(index * 20)}px; border-top: 15px solid ${chartColor}${item.value<20?20:item.value}; border-left: 15px solid ${chartColor}${ item.value<20?20:item.value }; `"></div>
            <!--<div class="circular-arc" style="clip-path: inset(0px 0px 60%); margin-top: -180px; margin-right: 20px; width: 160px; height: 160px; border-top: 15px solid #4DBEC7; border-left: 15px solid #4DBEC7; "></div>
            <div class="circular-arc" style="clip-path: inset(0px 0px 80%); margin-top: -140px; margin-right: 40px; width: 120px; height: 120px; border-top: 15px solid #7CD0D6; border-left: 15px solid #7CD0D6; "></div>
            <div class="circular-arc" style="clip-path: inset(0px 0px 80%); margin-top: -100px; margin-right: 60px; width: 80px; height: 80px; border-top: 15px solid #ADE1E5; border-left: 15px solid #ADE1E5; "></div>-->
        </div>
    </td>

</tr></table>
            

            
        </v-card-text>
        <v-card-text class="align-center" v-if="selectedChart === 'chart3'" style="margin:auto; margin-right: 80px; margin-top: -10px; margin-bottom: -20px;">
            <table>
                <tr>
                    <td v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                        <div class="vertical-bar" style="font-size: 21px;">
                            <div class="barcontainer" :style="{ height: item.value + '%' }">{{ item.value }}%<div class="bar" :style="{backgroundColor:chartColor}"></div></div>
                        </div>
                        <div class="barname" style="font-size: 21px;"><span>{{ item.name }}</span></div>
                    </td>
                </tr>
            </table>
            <!--<table>
        <tr>
            <td v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                <div class="vertical-bar">
                    <div class="barcontainer2" :style="{ height: item.value + '%' }"><div style=" background-color: white; border: 1px solid lightgray;padding:1px;width:auto;margin-top:-5px;margin-bottom:5px">{{ item.value }}%</div><div class="bar" :style="{backgroundColor:chartColor}"></div></div>
                    <div class="barname2">

                        <span>{{ item.name }}</span>
                    </div>
                </div>
            </td>
        </tr>
    </table>-->

        </v-card-text>
    </v-card>
</template>

<script>

    export default {

        props: {
            value: {
                type: Array,
                default: () => [],
            },

        },
        data() {
            return {

                selectedChart: 'chart1', // Default to horizontal view
                isColorPickerOpen: false, // Controls the dialog visibility
                chartColor: '#00bcd4', // Default chart color

            }
        },
    }
</script>

<style scoped>
    .chart-card {
        width: 30%;
        padding: 16px;
        background-color: #f5f5f5;
        border-radius: 8px;
    }

    .chart-title {
        background-color: #00bcd4;
        color: white;
        padding: 8px;
        border-radius: 4px;
        text-align: center;
    }

    .chart-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 8px;
    }

    .chart-bar {
        height: 35px;
        line-height: 35px;
        background-color: #00bcd4;
        color: white;
        text-align: right;
        padding-right: 8px;
 
        min-width: 0px;
    }

    .vertical-bar {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 120px;
        position: relative;
        margin:0 10px;
        width:50px;
    }

    .barcontainer {
        position: absolute;
        bottom: 110px;
        text-align: center;
    }

    .barname {
        position1: absolute;
        bottom1: 0px;
        width: 130px;
        word-wrap: break-word;
        height: 100px;
    }

        .barname span {
            display: block;
            transform: rotate(-60deg);
            width: 200px !important;
            margin-top: 5px;
            margin-right: -30px;
            height: 10px;
        }

    .barcontainer2 {
        position: absolute;
        bottom: 70px;
        text-align: center;
    }

    .bardivier {
        width: 90%;
        bottom: 178px;
        background-color: lightgray;
        height: 1px;
        position: absolute
    }

    .barname2 {
        position: absolute;
        bottom: 0px;
        font-size: 11px;
        text-align: center;
    }
    .barname2 span {
        display: block;
        transform: rotate(-70deg);
        width: 200px !important;
        margin-top: 60px;
        margin-right: 0px;
        height: 10px;
    }
    .bar {
        width: 50px;
        height: 100%;
        background-color: #00bcd4;
        color: white;
        text-align: center;
    }

    .titlebackground {
        background-image: url('/public/titlebackground.png');
        background-repeat: no-repeat;
        height: 51px;
        background-size: contain;
        width: 100%;
        color: white;
        padding: 0 10px;
        line-height: 51px;
        background-position: right
    }

    .circular-arc {
        width: 200px; /* Diameter of the circle */
        height: 200px; /* Diameter of the circle */
        border: 15px solid transparent; /* Creates the circular border, but makes it initially invisible */
        /* Color for the top arc */
        border-radius: 50%; /* Makes it circular */
        transform: rotate(-45deg); /* Adjusts the position of the arc */
        /* Clips the bottom and left parts */
    }

    

    table, tr, td {
        padding: 0px
    }
</style>
